import React from 'react'
import { useActions, useValues } from 'kea'
import { pricingSliderLogic } from './pricingSliderLogic'
import { LogSlider } from './LogSlider'

interface PricingSliderProps {
    marks?: number[]
    min?: number
    max?: number
    stepsInRange?: number
    pricingOption?: string
    crmPricingOption?: string
}

export const PricingSlider = ({
    marks = [10, 50, 100, 1000, 10000],
    min = 1,
    max = 15000,
    stepsInRange = 100,
}: PricingSliderProps) => {
    const { setPropertyManagemenSliderValue } = useActions(pricingSliderLogic)
    const { propertyManagemenSliderValue } = useValues(pricingSliderLogic)
    return (
        <LogSlider
            min={min}
            max={max}
            marks={marks}
            stepsInRange={stepsInRange}
            onChange={(value) => setPropertyManagemenSliderValue(value)}
            value={propertyManagemenSliderValue}
        />
    )
}
